module.exports = __webpack_public_path__ + "img/placeholder-landscape.4aa654f.jpg";